// hooks/useDebouncedSocketEmit.js
import { useEffect, useRef } from "react";
import { debounce } from "lodash";

export const useDebouncedSocketEmit = (
  socket,
  event = "updateStatePush",
  delay = 300
) => {
  const socketRef = useRef(socket);
  const eventRef = useRef(event);

  useEffect(() => {
    socketRef.current = socket;
    eventRef.current = event;
  }, [socket, event]);

  const debouncedEmit = useRef(
    debounce((data) => {
      if (socketRef.current) {
        socketRef.current.emit(eventRef.current, data);
      }
    }, delay)
  ).current;

  useEffect(() => () => debouncedEmit.cancel(), [debouncedEmit]);

  return debouncedEmit;
};
